import { hasPixParam } from "../../utils/getPreTickets";
import { CONCURSO_SELECTED, PRETICKETS_SELECTED } from "../concurso/concursoActions";
import { MODALIDADE_SELECTED, EXTRACOES_SELECTED } from "./loteriaActions";

const INITIAL_STATE = {
  listModalidade: [],
  modalidade: null,
  apostaDate: "",
  extracoesSelecionadas: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONCURSO_SELECTED:
      return { ...state, objTipoJogo: action.payload.objTipoJogo };
    case MODALIDADE_SELECTED:
      return { ...state, modalidade: action.payload };
    case EXTRACOES_SELECTED:
      const newlist = action.payload;
      return { ...state, extracoesSelecionadas: newlist };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loteria/loteriaReducer.js